import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getContentRequest, getContentRequestError, getContentRequestSuccess } from "../../slices/Content/GetContentSlice";

export const GetContentAPI = (type) => async (dispatch) => {
    try {
        dispatch(getContentRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getContent,
            params: type,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getContentRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getContentRequestError(_error));
            });
    } catch (error) { }
};
